import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderInformationService } from '../order-information/services/order-information.service';
import { AnalyticsService } from '../shared/services/analytics.service';
import { CommonService } from '../shared/services/common.service';
import { NgOtpInputModule } from 'ng-otp-input';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-otp-popup',
  templateUrl: './otp-popup.component.html',
  styleUrls: ['./otp-popup.component.scss'],
  standalone: true,
  imports: [
    NgOtpInputModule,
    FormsModule,
    CommonModule,
    MatButtonModule,
    FlexLayoutModule,
    MatIcon
  ]
})
export class OtpPopupComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<OtpPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderInformationService: OrderInformationService,
    private commonService: CommonService,
    private analyticServ: AnalyticsService
  ) { }
  ifOtpSent: boolean = false;
  otp: any = '';
  mobileNumber: any = null;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    autocomplete: 'off',
    inputClass: 'responsive-otp-input',
  };
  isBtnClicked: boolean = false;

  captchaTxt: string = ''
  captchaSrt: string | undefined;
  showCaptchaError: boolean = false;

  ngOnInit(): void {

  }
  ngAfterViewInit() {
    this.createCaptcha();
  }
  resendOTP() {
    this.commonService.showLoader();
    let obj = {
      awb_number: this.data.awb_number,
      contact_number: this.mobileNumber
    }
    this.orderInformationService.resendOTP(obj).subscribe({
      next: (response: any) => {
        if (response?.message == 'otp generated successfully') {
          this.ifOtpSent = true;
          this.commonService.showSuccess("OTP sent successfully")
        }
        this.analyticServ.sendEvent('submit_mobile_number', {
          pageName: 'track-details',
          trackingID: this.data.awb_number,
          status: 'Success'
        })
        this.commonService.hideLoader();
      },
      error: (error) => {
        this.commonService.showError(error.error);
        this.ifOtpSent = false;
        this.commonService.hideLoader();
      }
    });
  }
  verifyOTP() {
    this.commonService.showLoader();
    let obj = {
      awb_number: this.data.awb_number,
      otp: this.otp
    }
    this.orderInformationService.verifyOTP(obj).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.commonService.setCookie('sfxTrackToken', response.token);
          this.dialogRef.close(response);
          window.location.reload();
          this.analyticServ.sendEvent('otp_submission_successful', {
            pageName: 'track-details',
            trackingID: this.data.awb_number,
          })
        }
        if (!response.status) {
          this.commonService.deleteCookie('sfxTrackToken');
          this.commonService.setCookie('sfxTrackToken', '')
          this.commonService.showError(response);
        }
        this.commonService.hideLoader();
      },
      error: (error) => {
        this.commonService.hideLoader();
        this.commonService.showError(error.error);
      }
    });
  }
  sendOTP() {
    if (this.captchaTxt !== this.captchaSrt) {
      this.analyticServ.sendEvent(this.captchaTxt === "" ? 'empty_captcha_error' : 'wrong_captcha_error', { awb: this.data.awb_number });
      this.showCaptchaError = true;
      setTimeout(() => {
        this.showCaptchaError = false;
      }, 3000);
      this.createCaptcha();
      this.captchaTxt = '';
      return
    }
    this.commonService.showLoader();
    let obj = {
      awb_number: this.data.awb_number,
      contact_number: this.mobileNumber
    }
    this.orderInformationService.verifyPhoneNumber(obj).subscribe({
      next: (response: any) => {
        this.ifOtpSent = true;
        this.commonService.hideLoader();
        this.analyticServ.sendEvent('submit_mobile_number', {
          pageName: 'track-details',
          trackingID: this.data.awb_number,
          status: 'Success'
        })
      },
      error: (error) => {
        this.commonService.showError(error.error);
        this.ifOtpSent = false;
        this.commonService.hideLoader();
        this.analyticServ.sendEvent('submit_mobile_number', {
          pageName: 'track-details',
          trackingID: this.data.awb_number,
          status: 'Error'
        })
        this.createCaptcha();
        this.captchaTxt = '';
      }
    });

  }
  closePopup(): void {
    this.dialogRef.close(false);
  }
  createCaptcha() {
    //clear the contents of captcha div first
    this.captchaSrt = ''
    const captchaElement = document.getElementById('captcha');
    if (captchaElement) {
      captchaElement.innerHTML = "";
    }
    let charsArray =
      "0123456789abcdefghijklmnopqrstuvwxyz";
    //ABCDEFGHIJKLMNOPQRSTUVWXYZ
    let lengthOtp = 6;
    let captcha = [];
    for (let i = 0; i < lengthOtp; i++) {
      //below code will not allow Repetition of Characters
      let index = Math.floor(Math.random() * charsArray.length); //get the next character from the array
      if (captcha.indexOf(charsArray[index]) == -1)
        captcha.push(charsArray[index]);
      else i--;
    }
    let canv = document.createElement("canvas");
    canv.id = "captcha-canvas";
    canv.width = 105;
    canv.height = 40;
    let ctx = canv.getContext("2d");
    if (ctx) {
      ctx.font = "25px Georgia";
      ctx.textAlign = 'center';
      ctx.strokeText(captcha.join(""), 50, 30);
    }
    //storing captcha so that can validate you can save it somewhere else according to your specific requirements
    this.captchaSrt = captcha.join("");
    if (captchaElement) {
      captchaElement.appendChild(canv); // adds the canvas to the body element
    }
  }
  onOtpChange(event: any) {
    this.otp = event
  }
}
